import React, { useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";

import { AuthContext } from "../contexts/AuthContext";
import { ScreenContext } from "../contexts/ScreenContext";

import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Hidden from "@material-ui/core/Hidden";
import Typography from "@material-ui/core/Typography";

import Weather from "../components/Weather";
import Timezone from "../components/Timezone";
import HoursSummary from "../components/HoursSummary";
import MyNotes from "../components/MyNotes";
import SPClients from "../components/SPClients";
import DashBoardButtons from "../components/DashBoardButtons";
import DailyMessageForm from "../components/DailyMessageForm";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  noPadding: {
    padding: 0,
  },
}));

const Dashboard = () => {
  const classes = useStyles();
  const { isSuperAdmin } = useContext(AuthContext);
  const { isMobile } = useContext(ScreenContext);
  const [showMyNotes, setShowMyNotes] = useState(isMobile ? false : true);
  const [showDailyMessage, setshowDailyMessage] = useState(false);

  const toggleNote = () => {
    setShowMyNotes(!showMyNotes);
  };

  const toggleDailyMessage = () => {
    setshowDailyMessage(!showDailyMessage);
  };

  return (
    <React.Fragment>
      <Grid
        container
        alignItems="flex-start"
        justifyContent="space-between"
        spacing={2}
      >
        <Grid item md={3} xs={6}>
          <Timezone />
        </Grid>

        <Hidden only={["xs", "sm", "md"]}>
          <Grid item md={6}>
            <Typography
              align="center"
              variant="h6"
              display="block"
              gutterBottom
            >{`HOURS SUMMARY`}</Typography>
            <HoursSummary />
          </Grid>
        </Hidden>

        <Grid item md={3} xs={6}>
          <Weather />
        </Grid>

        <Hidden only={["lg", "xl"]}>
          <Grid item xs={12}>
            <HoursSummary />
          </Grid>
        </Hidden>
      </Grid>

      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          style={{ display: "flex", flexWrap: "nowrap", overflow: "hidden" }}
        >
          <DashBoardButtons
            toggleNote={toggleNote}
            toggleDailyMessage={toggleDailyMessage}
          />
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        {showMyNotes && (
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <MyNotes toggleNote={toggleNote} />
              </Grid>
            </Grid>
          </Grid>
        )}

        {showDailyMessage && isSuperAdmin && (
          <Grid item md={4} xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Paper
                  className={classes.paper}
                  elevation={0}
                  variant="outlined"
                >
                  <DailyMessageForm />
                </Paper>
              </Grid>
            </Grid>
          </Grid>
        )}

        <Grid item md xs={12} style={{ flexGrow: 1 }}>
          <Paper className={classes.paper} elevation={0} variant="outlined">
            <SPClients />
          </Paper>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default Dashboard;
